export const injectTermIntoSimpleSearch = (query: string): string => {
  return `contact CONTAINS "${query}" OR details CONTAINS "${query}"`;
};
